<template>
  <v-container fluid>
    <v-dialog v-model="dialog" max-width="50vw" max-height="50vh">
      <v-card>
        <v-card-title>
          <v-title>Update Customer Contact</v-title>
        </v-card-title>
        <v-card-text>
          <v-container fluid></v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="updateEmail"
              :rules="emailRules"
              label="Update Contact Email"
              required
            ></v-text-field>

            <v-text-field
              v-model="updateContactNumber"
              :rules="numberRules"
              label="Update Contact Number"
              required
            ></v-text-field>
            <v-btn :disabled="!valid" class="primary" @click="submit">
              Submit
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div>
      <v-layout row>
        <v-flex xs4>
          <v-text-field
            name="Search"
            label="Search"
            v-model="SearchText"
            append-icon="search"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </div>

    <v-data-table
      :total-items="totalItems"
      :pagination.sync="pagination"
      :items="filteredRows"
      :headers="headers"
      :loading="loading"
    >
      <template slot="items" slot-scope="props">
        <td
          v-for="(prop, propIndex) in headers.filter(
            (x) => x.text != 'Actions'
          )"
          :key="propIndex"
          :class="'ma-0'"
        >
          <div v-if="prop.autocomplete" :class="'text-xs-' + prop.align">
            {{ props.item[prop.value][prop.nested] }}
          </div>

          <div v-else :class="'text-xs-' + prop.align">
            {{ props.item[prop.value] }}
          </div>
        </td>

        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editItem(props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-flex sm12 md12 lg12>
      <message-alert :component="message"></message-alert>
    </v-flex>
  </v-container>
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex';
import { mapMultiRowFields } from 'vuex-map-fields';
import {
  mapCustomerDetailFields,
  mapCustomerDetailMultiRowFields,
} from '@/store/modules/orders';

const {
  mapActions: mapCustomerDetailActions,
  mapMutations: mapCustomerDetailMutations,
} = createNamespacedHelpers(`orders/customerDetail`);
import { httpError } from '@/models/httpError';
import { CustomerDetail } from '@/models/CustomerDetail';

export default {
  name: 'maintainCustomerContact',
  data: () => ({
    valid: true,
    dialog: false,
    editedItem: new CustomerDetail(),
    editedIndex: 0,
    SearchText: null,
    updateContactNumber: null,
    items: [],
    totalItems: 0,
    updateEmail: null,
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /.+@.+/.test(v) || 'E-mail must be valid',
    ],
    numberRules: [(v) => !!v || 'Contact Number is required'],
    pagination: {
      page: 1,
      rowsPerPage: 20,
      totalItems: 0,
    },
    loading: false,
    headers: [
      {
        text: 'Customer Number',
        align: 'right',
        sortable: true,
        value: 'customerNumber',
      },
      {
        text: 'Contact Email',
        align: 'right',
        sortable: true,
        value: 'contactEmail',
      },
      {
        text: 'Contact Number',
        align: 'right',
        sortable: true,
        value: 'contactNo',
      },
      {
        text: 'Actions',
        align: 'center',
        sortable: false,
      },
    ],
  }),

  computed: {
    ...mapCustomerDetailFields(['message']),
    ...mapCustomerDetailMultiRowFields(['rows']),

    filteredRows: function () {
      let result = this.items.filter(this.isValid);
      return result;
    },
  },

  methods: {
    ...mapCustomerDetailActions([
      'getCustomerContacts',
      'updateContact',
      'setMessage',
    ]),
    ...mapCustomerDetailMutations(['addRow']),
    getDataFromApi() {
      let vm = this;
      this.loading = true;
      return new Promise((resolve, reject) => {
        vm.getCustomerContacts().then((data) => {
          let items = data.data;
          const total = data.count;
          vm.loading = false;
          resolve({
            items,
            total,
          });
        });
      });
    },

    editItem(item) {
      this.setMessage(new httpError());
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = this.items[this.editedIndex];
      this.dialog = true;
    },

    isValid: function (item) {
      let vm = this;
      if (vm.SearchText === null) return true;
      const filters = vm.headers.filter((x) => x.sortable).map((x) => x.value);
      for (var i = 0; i < filters.length; i++) {
        if (item[filters[i]] !== null) {
          if (
            item[filters[i]]
              .toString()
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }
    },
    submit() {
      let vm = this;
      let newData = JSON.parse(JSON.stringify(vm.editedItem));
      if (vm.updateEmail != null) {
        newData.contactEmail = vm.updateEmail;
      }

      if (vm.updateContactNumber != null) {
        newData.contactNo = vm.updateContactNumber;
      }

      var request = { oldContact: vm.editedItem, newContact: newData };
      vm.updateContact(request)
        .then((data) => {})
        .catch((err) => {});
      this.dialog = false;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
  mounted() {
    let vm = this;
    this.$nextTick(() => {
      vm.setMessage(new httpError());
      vm.getCustomerContacts()
        .then((data) => {
          vm.items = data.data;
          vm.total = data.data.length;
          vm.loading = false;
        })
        .catch(() => {});
    });
  },
};
</script>
